// extracted by mini-css-extract-plugin
export var alignBaseline = "_j-9";
export var alignCenter = "_j-5";
export var alignFlexEnd = "_j-7";
export var alignFlexStart = "_j-6";
export var alignSelfBaseline = "_j-e";
export var alignSelfCenter = "_j-a";
export var alignSelfFlexEnd = "_j-c";
export var alignSelfFlexStart = "_j-b";
export var alignSelfStretch = "_j-d";
export var alignStretch = "_j-8";
export var column = "_j-2";
export var columnReverse = "_j-4";
export var flex = "_j-0";
export var justifyCenter = "_j-f";
export var justifyFlexEnd = "_j-h";
export var justifyFlexStart = "_j-g";
export var justifySpaceAround = "_j-j";
export var justifySpaceBetween = "_j-i";
export var justifySpaceEvenly = "_j-k";
export var row = "_j-1";
export var rowReverse = "_j-3";
export var wrapNowrap = "_j-m";
export var wrapWrap = "_j-l";
export var wrapWrapReverse = "_j-n";